<template>
  <ZipDownloadWarningModal
    :open="showZipDownloadModal"
    @download-zip-accepted="downloadTicketsZip()"
    @hide-modal="showZipDownloadModal = false" />
  <div v-if="totalItems === 1" class="text-center">
    <p class="font-bold text-xl">{{ event?.eventName || "Loading..." }}</p>
    <p>{{ event?.tournamentName }} ({{ event?.season }})</p>
    <p v-if="event?.dateStart && canShowDate">
      {{ event?.venueName }}, {{ event?.city }},
      <span>
        {{ displayDateTime(event?.dateStart, event?.dateStop, canShowTime) }}
      </span>
    </p>
  </div>

  <div :key="index" class="flex w-full justify-center gap-2 mb-5">
    <div class="flex flex-col w-full max-w-2xl mx-auto rounded overflow-hidden shadow-xl p-2 hover:opacity-100">
      <div
        class="flex w-full justify-between items-center text-xl text-bold p-4 cursor-pointer"
        @click="index > 0 ? openBoDetails(index) : ''">
        <div v-if="totalItems > 1" class="font-bold">
          {{ event?.eventName || "Loading..." }}
        </div>
        <div :id="`arrow-${index}`" :class="index > 0 ? `` : 'rotate-90'" class="ml-auto">
          <ChevronRightIcon v-if="totalItems > 1" class="w-5"></ChevronRightIcon>
        </div>
      </div>
      <div :id="`bo-${index}`" :class="index > 0 ? `p-2 hidden` : 'p-2'" class="px-4">
        <div v-if="showSpaSteps" class="grid text-sm gap-3 mb-3">
          <div class="gap-2 flex flex-col">
            <div>
              <span class="font-bold">{{ $t("Step {number}", { number: 1 }) }}</span>

              {{ $t("Open the ticket download link you received") }}
            </div>

            <div>
              <span class="font-bold">{{ $t("Step {number}", { number: 2 }) }}</span>

              {{ $t("Follow the link to the official Spa Grand Prix website") }}
            </div>

            <div>
              <span class="font-bold">{{ $t("Step {number}", { number: 3 }) }}</span>

              {{ $t("Log in to your existing Spa Grand Prix account or create a new account (this is required)") }}
            </div>

            <div>
              <span class="font-bold">{{ $t("Step {number}", { number: 4 }) }}</span>

              {{ $t("Enter your personal details") }}
            </div>

            <div>
              <span class="font-bold">{{ $t("Step {number}", { number: 5 }) }}</span>

              {{ $t("Download your ticket") }}
            </div>
          </div>
        </div>
        <div class="grid grid-cols-2 w-full">
          <div v-if="totalItems > 1">{{ event?.tournamentName }} ({{ event?.season }})</div>
          <div v-else></div>
          <div class="flex flex-col gap-1 items-end ml-auto mb-2">
            <button
              v-if="allowToDownload() && bookingOrder.zip_sha"
              class="text-xs sm:text-sm flex items-center gap-2 cursor-pointer"
              @click="downloadTicketsZipIntercept()">
              Download ZIP <DocumentCheckIcon class="text-primary h-6" />
            </button>
            <button
              v-if="validItineraries.length"
              class="text-xs sm:text-sm flex gap-3 items-center"
              @click="openItineraries">
              {{ $t("Open extra information") }}
              <InformationCircleIcon class="text-primary h-6" />
            </button>
          </div>
        </div>
        <div v-if="event?.date_start && totalItems > 1 && canShowDate">
          {{ event?.venueName }}, {{ event?.city }} -
          {{ formatDate(event?.dateStart) }}
          <span v-if="canShowTime">{{ formatTime(event?.dateStart) }}</span>
        </div>
        <div class="pb-4">
          <div v-for="[key, value] in Object.entries(countTickets(bookingOrder.items))">
            {{ value }} &times; {{ key }}
          </div>
        </div>
        <!-- <a
          v-if="categoryFiles.length > 0"
          class="mb-4 flex items-center gap-2 hover:text-opacity-10 underline"
          href="#"
          @click="downloadFiles()">
          Download ticketinfo <FolderArrowDownIcon class="w-6 text-primary" />
        </a> -->
        <div v-if="!allowToDownload() && !incompleteGuestdata">
          <p class="font-bold">
            {{ $t("Your tickets are not available yet!") }}
          </p>
          <p v-if="ticketDeliveryDays">
            {{ $t("Your e-tickets are expected to be available about") }}
            {{ ticketDeliveryDays }}
            {{ $t("days prior to the event. Please come back later to download your e-tickets.") }}
          </p>
          <p v-else>
            {{ $t("Please come back later to download your e-tickets.") }}
          </p>
          <div v-if="isWaitfornotify()" class="mt-3">
            <p class="font-bold">
              {{ $t("We will send you an email as soon as your tickets are available!") }}
            </p>
          </div>
          <div v-else>
            <notifyForm :bookingorder="bookingOrder" />
          </div>
        </div>

        <div v-else-if="deliveryState === 'external'" class="font-bold">
          {{ $t("You will receive the tickets for this order by an external distributor") }}.
        </div>

        <div v-else-if="deliveryState === 'unavailable'">
          <p class="font-bold">
            {{ $t("We are unable to show your tickets for this order right now.") }}
          </p>
          <p>
            {{ $t("Please contact us so we can sort this out for you as soon as possible.") }}
          </p>
        </div>

        <div v-else class="p-2">
          <div v-if="incompleteGuestdata" class="p-2">
            <Guests :bookingorder="bookingOrder" />
          </div>
          <BookingorderItem
            v-for="(item, idx) in bookingOrder?.items"
            v-else
            :item="item"
            :booking-order-id="bookingOrder?.bookingorder_id"
            :index="idx"
            :allow-download="allowToDownload()"
            :physical-tickets="physicalTickets" />
        </div>
      </div>
      <div v-if="extras.length && allowToDownload()" class="px-4 gap-4 pb-4">
        <div class="font-semibold">{{ $t("Extra's") }}</div>
        <div class="flex flex-col pt-7 overflow-auto max-h-48">
          <div
            v-for="(extra, index) in extras"
            :key="index"
            class="flex gap-3 text-sm lg:text-base flex-col lg:flex-row justify-between lg:items-center odd:bg-[#F7F8FC] py-3 px-4">
            <div class="flex gap-1 w-3/4 items-center">
              <DocumentIcon class="text-red-500 w-6 shrink-0" />
              <span class="">extra-{{ index }} </span>
            </div>
            <div class="flex gap-1 w-1/4 items-center lg:justify-end">
              <ArrowDownTrayIcon class="w-4 shrink-0"> </ArrowDownTrayIcon>
              <span
                class="underline cursor-pointer"
                @click="generatePdfLinks(extra.bookingorder_id, extra.bookingorderextra_id, index)"
                >{{ $t("Download") }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BookingorderItem, ZipDownloadWarningModal, NotifyForm, Guests } from "@/components/xs2ticket";
import { useBookingsStore } from "@/store/bookings.js";
import { useUserStore } from "@/store/user.js";
import { useEventStore } from "@/store/event.js";
import { onMounted, ref, computed } from "vue";
import dayjs from "dayjs";
import { formatDate, formatTime } from "@xs2event/js-lib";
import {
  ChevronRightIcon,
  DocumentCheckIcon,
  // FolderArrowDownIcon,
  InformationCircleIcon,
} from "@heroicons/vue/24/solid";
import { useRoute } from "vue-router";
import { ArrowDownTrayIcon, DocumentIcon } from "@heroicons/vue/24/outline";
import {
  CategoryResponse,
  DateVisibility,
  EventResponse,
  //  CategoryFileResponse
} from "@xs2event/js-lib/api";
import { startDownload } from "@/helpers/download";
import { useToast } from "@xs2event/js-lib/toast";
import { useItineraries } from "@xs2event/js-lib/composables";
import { hasIncompleteGuestdata, hasPhysicalTickets, resolveDeliveryState } from "@/helpers/ticketDelivery";

const eventStore = useEventStore();
const bookingsStore = useBookingsStore();
const userStore = useUserStore();
const route = useRoute();
const event = ref<EventResponse | null>(null);
const { bookingOrder, index } = defineProps(["bookingOrder", "index", "totalItems"]);
// const categoryFiles = ref<CategoryFileResponse[]>([]);
const showZipDownloadModal = ref(false);
const extras = ref<[]>([]);
const toast = useToast();

const displayDateTime = (eventStartDate: string, eventStopDate: string, showTime: boolean) => {
  const withTime = (date: string) => `${formatDate(date)} ${showTime ? formatTime(date) : ""}`.trim();

  if (!eventStopDate || dayjs(eventStartDate).isSame(eventStopDate, "day")) return withTime(eventStartDate);

  return `${withTime(eventStartDate)} - ${withTime(eventStopDate)}`;
};

const getEvent = () => {
  eventStore.fetchEvent(bookingOrder?.event_id).then((eventRes) => {
    event.value = eventRes;
  });
};

const { openItineraries, validItineraries } = useItineraries(
  bookingOrder.items.map((item) => ({ bookingorderId: bookingOrder.bookingorder_id, ticketId: item.ticket_id }))
);

const countTickets = (items) => {
  if (items) {
    return items.reduce(
      (acc, value) => ({
        ...acc,
        [value.ticket_name]:
          (acc[value.ticket_name] || 0) + (value.ticket_status !== "returned" && value.quantity > 0 ? 1 : 0),
      }),
      {}
    );
  }
};

const getExtras = async (bookingOrderId: string) => {
  extras.value = await bookingsStore.fetchBookingOrderExtras({ bookingOrderId: bookingOrderId });
};

onMounted(() => {
  getExtras(bookingOrder.bookingorder_id);
  getEvent();
  gatherItineraryFiles();

  if (deliveryState.value === "unavailable") {
    // Should not happen - a bookingorder we cannot say anything useful about is bad data (a broken
    // category_id, missing download items). Leave a trace so it can be traced back to the order.
    console.warn("No tickets and no distribution channel to show for bookingorder", bookingOrder?.bookingorder_id);
  }
});

const physicalTickets = computed(() => hasPhysicalTickets(bookingOrder?.items));

// Which of the three stories we can tell about this order: hand over the tickets, point at the
// external distributor, or admit we have nothing and ask the customer to contact us.
const deliveryState = computed(() => resolveDeliveryState(bookingOrder));

const openBoDetails = (index: number) => {
  document.getElementById(`bo-${index}`).classList.toggle("hidden");
  document.getElementById(`arrow-${index}`).classList.toggle("rotate-90");
};

const allowToDownload = () => {
  const eventStartMs = new Date(bookingOrder?.items[0]?.ticket_startdate).getTime();
  const nowMs = new Date().getTime();
  const hoursBeforeEvent = (eventStartMs - nowMs) / (1000 * 60 * 60);
  const gracePeriodInHours = Number(userStore._distributor.grace_period_download_tickets) * 24;

  return (
    (bookingOrder?.distributorfinancial_status === "paid" && bookingCompleted()) ||
    (bookingOrder?.distributorfinancial_status !== "paid" &&
      hoursBeforeEvent <= gracePeriodInHours &&
      bookingCompleted())
  );
};

const showSteps =
  userStore._distributor.distributor_name === "Socialdeal" ||
  userStore._distributor.distributor_name === "Emesa" ||
  userStore._distributor.distributor_name === "TTIC B.V.";

const showSpaSteps = computed(
  () => showSteps && bookingOrder?.event_id === "c25e59d32195463faafe41244d672a8b_spp" && allowToDownload()
);

const incompleteGuestdata = computed(() => hasIncompleteGuestdata(bookingOrder));

const bookingCompleted = () => {
  return bookingOrder.logistic_status === "completed";
};

const downloadTicketsZipIntercept = () => {
  showZipDownloadModal.value = true;
};

const downloadTicketsZip = () => {
  showZipDownloadModal.value = false;
  const zipFileName = route.params.code ? route.params.code : bookingOrder.bookingorder_id;
  const payload = {
    bookingOrderId: bookingOrder.bookingorder_id,
    fileName: zipFileName,
  };
  bookingsStore
    .downloadTicketsAsZip(payload)
    .then()
    .catch((e) => {
      console.log(e);
    });
};

const categories = ref<CategoryResponse[]>([]);

const gatherItineraryFiles = () => {
  const category_ids = new Set();

  bookingOrder.items.forEach((i) => {
    // category_id 0 is a broken booking item - querying for it only returns an error.
    if (i.category_id) category_ids.add(i.category_id);
  });
  const unique_category_ids = [...category_ids];
  if (!unique_category_ids.length) return;

  eventStore
    .getCategories(`in:[${unique_category_ids}]`)
    .then((res) => {
      categories.value = res.categories;
    })
    .catch((e) => {
      console.log(e);
    });
  // .then(() => {
  //   categories.value.forEach((c) => {
  //     c?.files.forEach((f) => {
  //       categoryFiles.value.push(f);
  //     });
  //   });
  // });
};

const generatePdfLinks = async (bookingOrderId: string, bookingOrderExtraId: string, index: number) => {
  try {
    const extraData = await bookingsStore.downloadBookingOrderExtra({
      bookingOrderId: bookingOrderId,
      bookingOrderExtraId: bookingOrderExtraId,
    });

    const url = window.URL.createObjectURL(new Blob([extraData], { type: "application/pdf" }));
    startDownload(url, "extra-" + index);
  } catch (err) {
    if (err instanceof Error) {
      toast.addToast({
        title: "Error",
        content: "Something went wrong while downloading the extras.",
        status: "error",
      });
    }
  }
};

// const downloadFiles = () => {
//   categoryFiles.value.forEach((cf) => {
//     startDownload(
//       `https://cdn.xs2event.com/category-files/${cf.categoryId}/${cf.informationFilename}`,
//       cf.informationFilename
//     );
//   });
// };

const isWaitfornotify = () => bookingOrder?.notify_client_status === "waitfornotify";

const ticketDeliveryDays = computed(() => categories.value?.[0]?.ticketDeliveryDays);

const canShowDate = computed(() => event.value?.dateVisibility !== DateVisibility.Hidden);

const canShowTime = computed(() => {
  if (event.value?.dateVisibility === DateVisibility.ShowDateOnly) return false;
  return !!event.value?.dateConfirmed;
});
</script>
